module.exports = __webpack_public_path__ + "NagnathChippa-df610805.webp";